const notes30 = () => import('@/pages/notes30/index.vue');
export default [
  {
    path: '/notes30',
    component: notes30,
    meta: {
      title: '学习笔记征集',
    },
  },
];
